import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/locationgcc/game/unleash_game.webp";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section
      className="voice_services why_choose_speech p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              <span>Unleash Excellence:</span> Your Premier Choice for Game
              Development Services
            </h2>
            <p>
              No matter your target market, TekRevol as a leading{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development-company-dubai">
                app development company
              </Link>{" "}
              can build a mobile game that can work on multiple operating
              systems and fit multiple screen sizes with ultimate ease. Our
              approach towards developing the most exquisite digital experience,
              coupled with our experience building highly engaging games with
              incredible graphics, helps us win and get through every thick and
              thin. We focus on delivering the best to our clients, keeping the
              user experience top-notch and uncompromised while ensuring
              excellence.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>iOS Game Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our experienced iOS game development team has built
                      several amazing games for iPhone devices with millions of
                      cumulative downloads. Among many platforms, it is one of
                      the platforms that we specialize in developing mobile
                      games for, no matter the requirements.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Android Game Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      TekRevol’s Android game development experts know how to
                      build highly interactive and feature-rich games with
                      exceptional graphics. If you need to develop a
                      quick-to-load yet a unique mobile game that your audience
                      will love, we can perfectly build that game for you.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>iPad Game Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      iPad game development is not much different from iOS
                      development, but the requirements for screen alignments
                      and adjustments are different. Having significant
                      experience in the process, we know what it takes to design
                      and develop a fascinating mobile game.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Wearable Game Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Wearable game development services by TekRevol are focused
                      on delivering for the audience using smart devices in
                      their daily routine. From Android smart devices to iOS
                      smart devices, we develop for it all. Embracing the
                      future, we present a new way for everyone.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Android TV/Apple TV Game Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We have built some fantastic game apps for the bigger
                      screens of the already-famous Android and iOS systems,
                      allowing users to interact and experience a whole new
                      immersive experience. Our game development services have
                      got you covered.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>AR/VR Game Development</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      At TekRevol we take pride in creating magic in our gaming
                      experiences using cutting-edge AR and VR technologies. By
                      integrating these advanced technologies into our games, we
                      transport players into another world that is visually
                      captivating and dynamic and offers unparalleled
                      engagement.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
